const AREA_CODES = {
  '201':'Jersey City, NJ','202':'Washington, DC','203':'Bridgeport, CT','205':'Birmingham, AL',
  '206':'Seattle, WA','207':'Portland, ME','208':'Boise, ID','209':'Stockton, CA',
  '210':'San Antonio, TX','212':'New York, NY','213':'Los Angeles, CA','214':'Dallas, TX',
  '215':'Philadelphia, PA','216':'Cleveland, OH','217':'Springfield, IL','218':'Duluth, MN',
  '219':'Gary, IN','224':'Chicago Suburbs, IL','225':'Baton Rouge, LA','228':'Gulfport, MS',
  '229':'Albany, GA','231':'Muskegon, MI','234':'Akron, OH','239':'Fort Myers, FL',
  '240':'Silver Spring, MD','248':'Troy, MI','251':'Mobile, AL','252':'Greenville, NC',
  '253':'Tacoma, WA','254':'Killeen, TX','256':'Huntsville, AL','260':'Fort Wayne, IN',
  '262':'Kenosha, WI','267':'Philadelphia, PA','269':'Kalamazoo, MI','270':'Bowling Green, KY',
  '276':'Bristol, VA','281':'Houston, TX','301':'Silver Spring, MD','302':'Wilmington, DE',
  '303':'Denver, CO','304':'Charleston, WV','305':'Miami, FL','307':'Cheyenne, WY',
  '308':'Grand Island, NE','309':'Peoria, IL','310':'Los Angeles, CA','312':'Chicago, IL',
  '313':'Detroit, MI','314':'St. Louis, MO','315':'Syracuse, NY','316':'Wichita, KS',
  '317':'Indianapolis, IN','318':'Shreveport, LA','319':'Cedar Rapids, IA','320':'St. Cloud, MN',
  '321':'Orlando, FL','323':'Los Angeles, CA','325':'Abilene, TX','330':'Akron, OH',
  '331':'Aurora, IL','332':'New York, NY','334':'Montgomery, AL','336':'Greensboro, NC',
  '337':'Lafayette, LA','339':'Boston, MA','346':'Houston, TX','347':'New York, NY',
  '351':'Lowell, MA','352':'Gainesville, FL','360':'Vancouver, WA','361':'Corpus Christi, TX',
  '385':'Salt Lake City, UT','386':'Daytona Beach, FL','401':'Providence, RI','402':'Omaha, NE',
  '404':'Atlanta, GA','405':'Oklahoma City, OK','407':'Orlando, FL','408':'San Jose, CA',
  '409':'Beaumont, TX','410':'Baltimore, MD','412':'Pittsburgh, PA','413':'Springfield, MA',
  '414':'Milwaukee, WI','415':'San Francisco, CA','417':'Springfield, MO','419':'Toledo, OH',
  '423':'Chattanooga, TN','424':'Los Angeles, CA','425':'Bellevue, WA','430':'Tyler, TX',
  '432':'Midland, TX','434':'Charlottesville, VA','435':'St. George, UT','440':'Lorain, OH',
  '442':'Oceanside, CA','443':'Baltimore, MD','469':'Dallas, TX','470':'Atlanta, GA',
  '475':'Bridgeport, CT','478':'Macon, GA','479':'Fort Smith, AR','480':'Mesa, AZ',
  '484':'Allentown, PA','501':'Little Rock, AR','502':'Louisville, KY','503':'Portland, OR',
  '504':'New Orleans, LA','505':'Albuquerque, NM','507':'Rochester, MN','508':'Worcester, MA',
  '509':'Spokane, WA','510':'Oakland, CA','512':'Austin, TX','513':'Cincinnati, OH',
  '515':'Des Moines, IA','516':'Hempstead, NY','517':'Lansing, MI','518':'Albany, NY',
  '520':'Tucson, AZ','530':'Redding, CA','531':'Omaha, NE','539':'Tulsa, OK',
  '540':'Roanoke, VA','541':'Eugene, OR','551':'Jersey City, NJ','559':'Fresno, CA',
  '561':'West Palm Beach, FL','562':'Long Beach, CA','563':'Davenport, IA','567':'Toledo, OH',
  '571':'Arlington, VA','573':'Columbia, MO','574':'South Bend, IN','575':'Las Cruces, NM',
  '580':'Lawton, OK','585':'Rochester, NY','586':'Warren, MI','601':'Jackson, MS',
  '602':'Phoenix, AZ','603':'Manchester, NH','605':'Sioux Falls, SD','606':'Ashland, KY',
  '607':'Binghamton, NY','608':'Madison, WI','609':'Trenton, NJ','610':'Reading, PA',
  '612':'Minneapolis, MN','614':'Columbus, OH','615':'Nashville, TN','616':'Grand Rapids, MI',
  '617':'Boston, MA','618':'Alton, IL','619':'San Diego, CA','620':'Dodge City, KS',
  '623':'Phoenix, AZ','626':'Pasadena, CA','628':'San Francisco, CA','629':'Nashville, TN',
  '630':'Naperville, IL','631':'Suffolk County, NY','636':'O\'Fallon, MO','641':'Mason City, IA',
  '646':'New York, NY','650':'San Mateo, CA','651':'St. Paul, MN','657':'Anaheim, CA',
  '660':'Sedalia, MO','661':'Bakersfield, CA','662':'Tupelo, MS','667':'Baltimore, MD',
  '669':'San Jose, CA','678':'Atlanta, GA','681':'Charleston, WV','682':'Fort Worth, TX',
  '701':'Fargo, ND','702':'Las Vegas, NV','703':'Arlington, VA','704':'Charlotte, NC',
  '706':'Augusta, GA','707':'Santa Rosa, CA','708':'Cicero, IL','712':'Sioux City, IA',
  '713':'Houston, TX','714':'Anaheim, CA','715':'Eau Claire, WI','716':'Buffalo, NY',
  '717':'Lancaster, PA','718':'New York, NY','719':'Colorado Springs, CO','720':'Denver, CO',
  '724':'New Castle, PA','725':'Las Vegas, NV','726':'San Antonio, TX','727':'St. Petersburg, FL',
  '731':'Jackson, TN','732':'New Brunswick, NJ','734':'Ann Arbor, MI','737':'Austin, TX',
  '740':'Lancaster, OH','747':'Los Angeles, CA','754':'Fort Lauderdale, FL','757':'Virginia Beach, VA',
  '760':'Oceanside, CA','762':'Augusta, GA','763':'Brooklyn Park, MN','765':'Muncie, IN',
  '769':'Jackson, MS','770':'Roswell, GA','773':'Chicago, IL','774':'Worcester, MA',
  '775':'Reno, NV','779':'Rockford, IL','781':'Boston, MA','786':'Miami, FL',
  '801':'Salt Lake City, UT','802':'Burlington, VT','803':'Columbia, SC','804':'Richmond, VA',
  '805':'Ventura, CA','806':'Lubbock, TX','808':'Honolulu, HI','810':'Flint, MI',
  '812':'Evansville, IN','813':'Tampa, FL','814':'Erie, PA','815':'Rockford, IL',
  '816':'Kansas City, MO','817':'Fort Worth, TX','818':'Los Angeles, CA','828':'Asheville, NC',
  '830':'New Braunfels, TX','831':'Salinas, CA','832':'Houston, TX','843':'Charleston, SC',
  '845':'New City, NY','847':'Evanston, IL','848':'New Brunswick, NJ','850':'Tallahassee, FL',
  '856':'Camden, NJ','857':'Boston, MA','858':'San Diego, CA','859':'Lexington, KY',
  '860':'Hartford, CT','862':'Newark, NJ','863':'Lakeland, FL','864':'Greenville, SC',
  '865':'Knoxville, TN','870':'Jonesboro, AR','872':'Chicago, IL','878':'Pittsburgh, PA',
  '901':'Memphis, TN','903':'Tyler, TX','904':'Jacksonville, FL','906':'Sault Ste. Marie, MI',
  '907':'Anchorage, AK','908':'Elizabeth, NJ','909':'San Bernardino, CA','910':'Fayetteville, NC',
  '912':'Savannah, GA','913':'Kansas City, KS','914':'Yonkers, NY','915':'El Paso, TX',
  '916':'Sacramento, CA','917':'New York, NY','918':'Tulsa, OK','919':'Raleigh, NC',
  '920':'Green Bay, WI','925':'Concord, CA','928':'Flagstaff, AZ','929':'New York, NY',
  '931':'Clarksville, TN','936':'Conroe, TX','937':'Dayton, OH','940':'Denton, TX',
  '941':'Sarasota, FL','947':'Troy, MI','949':'Irvine, CA','951':'Riverside, CA',
  '952':'Bloomington, MN','954':'Fort Lauderdale, FL','956':'Laredo, TX','970':'Fort Collins, CO',
  '971':'Portland, OR','972':'Dallas, TX','973':'Newark, NJ','978':'Lowell, MA',
  '979':'College Station, TX','980':'Charlotte, NC','984':'Raleigh, NC','985':'Houma, LA',
};

export const getAreaCode = (phone) => {
  if (!phone) return null;
  const digits = phone.replace(/\D/g, '');
  if (digits.length >= 10) {
    return digits.startsWith('1') ? digits.substring(1, 4) : digits.substring(0, 3);
  }
  if (digits.length === 3) return digits;
  return null;
};

export const lookupAreaCode = (areaCode) => {
  if (!areaCode) return { city: 'Unknown', state: '--' };
  const entry = AREA_CODES[areaCode];
  if (!entry) return { city: 'Unknown', state: '--' };
  const parts = entry.split(', ');
  return { city: parts[0], state: parts[1] || '--' };
};

export default AREA_CODES;
